<template>
    <v-container class="inner-main pt-2 mb-10">
        <v-row class="mx-0">
            <h2 style="text-decoration:line-through;">{{ $t('global.menu.backoffice.manageUsers') }}</h2> <v-icon color="error">mdi-stop</v-icon><h2> ONLY FOR DEV PURPOSE MERCHANTS</h2><v-icon color="error">mdi-stop</v-icon>
        </v-row>
        <v-row class="mb-3">
            <v-data-table-server v-model:items-per-page="itemsPerPage" :items-per-page-options="pageOptions"
                density="compact" :headers="headers" :items="serverItems" :items-length="totalItems" :loading="loading"
                :search="search" item-value="name" @update:options="loadItems" height="60vh" fixed-header
                :mobile="['xs', 'sm', 'md'].includes($globalState.screenWidth)" class="shop-list-table">
                <template v-slot:top>
                    <v-row>
                        <v-col>
                            <!-- TODO BACKEND SEARCH FUNCTION PAGINATION -->
                            <v-text-field v-model="search" :disabled="true" :placeholder="$t('main.search.placeholder')"
                                variant="outlined" hide-details="true" density="compact" class="pb-2 py-0 bg-white"
                                height="32px">
                                <template v-slot:append-inner>
                                    <v-icon icon="mdi-magnify"></v-icon>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="4" class="text-right">
                            <v-btn color="primary" variant="flat" class="mr-1" rounded="xl" size="large"
                                @click="showMerchantDialog = true">
                                {{ $t('global.menu.backoffice.merchant') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:[`item.info`]="props">
                    <v-tooltip>
                        <template v-slot:activator="{ props }">
                            <v-icon v-bind="props">mdi-information-variant</v-icon>
                        </template>
                        <span>registered: {{ $formatDate(props.item.registered) }}</span><br>
                        <span>last Login: {{ $formatDate(props.item.lastLogin || null) }}</span>
                    </v-tooltip>
                </template>

                <template v-slot:[`item.controls`]>
                    <v-menu class="actions-menu">
                        <template v-slot:activator="{ props }">
                            <v-btn v-bind="props" size="x-small" class="mx-2" flat dark x-small color="transparent"
                                icon="mdi-chevron-down">
                            </v-btn>
                        </template>
                        <v-list :density="'compact'" lines="false">
                            <v-list-item density="compact">
                                <v-list-item-title><v-icon size="x-small" color="error">mdi-cancel</v-icon>
                                    activate</v-list-item-title>
                            </v-list-item>
                            <v-list-item density="compact">
                                <v-list-item-title><v-icon size="x-small" color="black">mdi-email-outline</v-icon> send
                                    credentials</v-list-item-title>
                            </v-list-item>
                            <v-list-item density="compact">
                                <v-list-item-title><v-icon size="x-small" color="black">mdi-cached</v-icon> send
                                    reminder</v-list-item-title>
                            </v-list-item>
                            <v-list-item density="compact">
                                <v-list-item-title><v-icon size="x-small" color="error">mdi-trash-can-outline</v-icon>
                                    delete
                                    shop</v-list-item-title>
                            </v-list-item>
                            <v-list-item density="compact">
                                <v-list-item-title><v-icon size="x-small" color="black">mdi-file-outline</v-icon>
                                    changelog</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>

                </template>

            </v-data-table-server>
        </v-row>
        <CreateMerchantDialog v-model="showMerchantDialog" v-model:data="merchantObj" :save="save">
        </CreateMerchantDialog>

    </v-container>
</template>

<script>
import { ref, inject, getCurrentInstance, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import CreateMerchantDialog from './modals/CreateMerchantDialog.vue';

export default {
    components: {
        CreateMerchantDialog
    },
    setup() {

        const { proxy } = getCurrentInstance();
        const router = useRouter();
        const selectedLanguage = localStorage.getItem('selectedLanguage');
        const { t, locale } = useI18n();
        const showMerchantDialog = ref(false)
        const merchantObj = ref({})
        const softToken = localStorage.getItem("softToken");
        const hardToken = localStorage.getItem("hardToken");
        const username = localStorage.getItem("username");

        const save = async () => {
            const copy = { ...merchantObj.value }
            console.log(copy);
            try {
                const response = await proxy.$axios.post(`/backoffice/merchants`, copy, {
                    headers: {
                        'X-Auth-HARDTOKEN': hardToken,
                        'X-Auth-SOFTTOKEN': softToken,
                        'X-Auth-USER': username
                    },
                });
                if (response.data.status == "OK") {
                    showMerchantDialog.value = false;
                    proxy.loadItems({ page: proxy.countryPage, itemsPerPage: proxy.itemsPerPage })
                }

            } catch (error) {
                console.error("Error fetching search results:", error);
            }
        }

        return {
            selectedLanguage,
            showMerchantDialog,
            merchantObj,
            save
        };
    },

    watch: {

    },

    data: () => ({
        itemsPerPage: 50,

        pageOptions: [
            { value: 50, title: '50' },
            { value: 100, title: '100' },
            { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
        ],
        headers: [
            { title: 'Username', key: 'username', align: 'start', maxWidth: "200px" },
            { title: 'Email', key: 'email', align: 'start' },
            { title: 'Roles', key: 'roles', align: 'start' },
            { title: 'Status', key: 'status', align: 'start' },
            { title: 'Info', value: "info", align: 'end', sortable: false },
            { title: 'Actions', value: "controls", align: 'end', sortable: false },
        ],
        search: '',
        serverItems: [],
        loading: true,
        totalItems: 0,
    }),

    computed: {
    },

    mounted() {
    },

    methods: {
        loadItems({ page, itemsPerPage, sortBy }) {
            this.loading = true
            console.log(this.search)
            const hardToken = localStorage.getItem("hardToken");
            const username = localStorage.getItem("username");
            this.$axios.get(this.search.length >= 1 ? "/backoffice/shop/query" : "/backoffice/merchants", {
                headers: {
                    'X-Auth-HARDTOKEN': hardToken,
                    'X-Auth-USER': username
                },
                params: {
                    ...(this.search.length >= 1 ? { name: this.search, resultsPerPage: itemsPerPage, page: page - 1 } : { page: page - 1, resultsPerPage: itemsPerPage })
                }
            })
                .then(this.itemsFetched)
                .catch(error => {
                    console.error("Error fetching user data:", error);
                    // You can handle specific error codes here, for example, a 401 Unauthorized
                    if (error.response && error.response.status === 401 || error.response.status === 403) {
                        // Handle token expiration or unauthorized error
                        console.log("Session expired or unauthorized. Please log in again.");
                        // Optionally log the user out or redirect to login page
                    }
                });
        },
        itemsFetched(response) {
            console.log(response)
            this.serverItems = response.data.data;
            this.totalItems = response.data.totalElements
            this.loading = false
        }
    },
}
</script>

<style scoped>
.inner-main {
    margin-left: auto;
    margin-right: auto;
    max-width: 1170px;
    margin-top: 40px;
}
</style>

<style></style>

<style></style>